import {Component} from '@angular/core';
import {NavHeaderComponent} from "./nav-header/nav-header.component";
import {ServicesComponent} from "./services/services.component";
import {MatIconModule} from "@angular/material/icon";
import {WorksComponent} from "./works/works.component";
import {AboutComponent} from "./about/about.component";
import {StatisticsComponent} from "./statistics/statistics.component";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {FooterComponent} from "./footer/footer.component";
import {PartnersComponent} from "./partners/partners.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [
    NavHeaderComponent,
    MatIconModule,
    ServicesComponent,
    WorksComponent,
    AboutComponent,
    StatisticsComponent,
    ContactUsComponent,
    FooterComponent,
    PartnersComponent,
  ]
})
export class HomeComponent {}
